import React, {Component} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Row, Col} from 'antd'
import { FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../request'
import _ from 'lodash'


@Form.create()

class notificationTemplates extends Component {
  state = {
    allNotifications:[],
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    typeArr:['Board', 'University']
  }


  handleSubmit = e => {
    const { form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
        if(!err) {
            let values = _.clone(valData);
            let x = null
            x = await Request.AddNotifications(values)
            if (!x.error) {
              notification.success({
                  message: x.message
              })
          } else {
              notification.error({
                  message: 'Error Saving',
                  description: x.message
              })
          }
        }
    })
  }

  async componentWillMount() {
  }

  async componentDidMount() {
    let response = await Request.getAllNotificationDetails();    
    setTimeout(() => {
      this.props.form.setFieldsValue(response.data);
    }, 10);
  }

  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    // const loginInputTypes = {
    //   fields: [
    //     {
    //         label:"Wrong Credentials",
    //         key:"wrongCredentials",
            // required:true,
    //         type:'text'
    //     },
    //     {
    //         label:"Login Success",
    //         key:"loginSuccess",
    //         required:true,
    //         type:'text'
    //     }
    //   ]
    // };
    const taskManagementInputTypes = {
        fields: [
          {
              label:"Task Added",
              key:"taskAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Task Forward",
              key:"taskForward",
            //   required:true,
              type:'text'
          },
          {
              label:"Task Postpone",
              key:"taskPostpone",
            //   required:true,
              type:'text'
          },
          {
              label:"Task Completed",
              key:"taskCompleted",
            //   required:true,
              type:'text'
          },
          {
              label:"Note Added",
              key:"noteAdded",
            //   required:true,
              type:'text'
          }
        ]
      };

      const addUpdateLeadInputTypes = {
        fields: [
          {
              label:"Inquiry Added",
              key:"inquiryAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Inquiry Update",
              key:"inquiryupdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Remove",
              key:"remove",
            //   required:true,
              type:'text'
          },
          {
              label:"Inquiry Basic Info Update",
              key:"inquiryBasicInfoUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Inquiry Abroad Information Update",
              key:"inquiryAboardInfoUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Inquiry Preference Update",
              key:"inquiryPreferenceUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Inquiry Qualification/Job Update",
              key:"inquiryQualOrJobUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Inquiry Passport Info Update",
              key:"inquiryPassportInfoUpdate",
            //   required:true,
              type:'text'
          },
          {
            label:"Counselling Update",
            key:"counsellingupdate",
            // required:true,
            type:'text'
        },
        {
            label:"Registration Update",
            key:"registerationupdate",
            // required:true,
            type:'text'
        },
        ]
      };
      const addUpdateRawInquiryInputTypes = {
        fields: [
          {
              label:"Raw Inquiry Added",
              key:"rawInquiryAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Assign Counsellor",
              key:"assignCounsellor",
            //   required:true,
              type:'text'
          },
          {
              label:"Counsellor Not Assigned",
              key:"noCounsellorAssign",
            //   required:true,
              type:'text'
          },
          {
              label:"Update Raw Inquiry",
              key:"updateRawInquiry",
            //   required:true,
              type:'text'
          },
          {
              label:"Move Raw Inquiry",
              key:"moveRawInquiry",
            //   required:true,
              type:'text'
          },
          {
              label:"Delete Raw Inquiry",
              key:"deleteRawInquiry",
            //   required:true,
              type:'text'
          }
        ]
      };
      const addUpdateVisitorVisaInputTypes = {
        fields: [
          {
              label:"Visa Inquiry Added",
              key:"visaInquiryAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Visa Inquiry Update",
              key:"visaInquiryUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Delete Visitor Visa Inquiry",
              key:"deleteVisitorVisaInquiry",
            //   required:true,
              type:'text'
          }
        ]
      };
      const facebookAndGoogleInputTypes = {
        fields: [
          {
              label:"Facebook Data Import",
              key:"facebookDataImport",
            //   required:true,
              type:'text'
          },
          {
              label:"Google Data Import",
              key:"googleDataImport",
            //   required:true,
              type:'text'
          },
          {
              label:"Setting Update",
              key:"facebookSettingUpdate",
            //   required:true,
              type:'text'
          }
        ]
      };
      const counsellingDeskInputTypes = {
        fields: [
          {
              label:"Choose 1 Course",
              key:"chooseOneCourse",
            //   required:true,
              type:'text'
          },
          {
              label:"Select Registrar",
              key:"selectRegistrar",
            //   required:true,
              type:'text'
          },
          {
            label:"Moved Success",
            key:"successMovedToRegisteration",
            // required:true,
            type:'text'
        }
        ]
      };
      const registrationDeskInputTypes = {
        fields: [
          {
              label:"Registration Desk Update",
              key:"registerationDeskUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Select Admission User",
              key:"selectAdmissionUser",
            //   required:true,
              type:'text'
          },
          {
              label:"Moved Success",
              key:"successMovedToApplication",
            //   required:true,
              type:'text'
          }
        ]
      };
      const submitFeesDeskInputTypes = {
        fields: [
          {
              label:"Payment Success",
              key:"paymentSuccess",
            //   required:true,
              type:'text'
          }
        ]
      };
      const accountPaymentsDeskInputTypes = {
        fields: [
          {
              label:"Account Payment Add",
              key:"accountPaymentAdd",
            //   required:true,
              type:'text'
          },
          {
              label:"Account Payment Delete",
              key:"accountPaymentDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const applicationDeskInputTypes = {
        fields: [
          {
              label:"Inquiry Passport Info",
              key:"inquiryPassportInfo",
            //   required:true,
              type:'text'
          },
          {
              label:"Select Visa Desk User",
              key:"selectVisaDeskUser",
            //   required:true,
              type:'text'
          },
          {
              label:"Agreement Signed",
              key:"agreementSigned",
            //   required:true,
              type:'text'
          },
          {
              label:"Moved to Visa Desk",
              key:"movedToVisaDesk",
            //   required:true,
              type:'text'
          }
        ]
      };
      const visaDeskInputTypes = {
        fields: [
          {
              label:"File Status",
              key:"visaFileStatus",
            //   required:true,
              type:'text'
          }
        ]
      };
      const archiveDeskInputTypes = {
        fields: [
          {
              label:"Expect Document",
              key:"archiveExpectDocument",
            //   required:true,
              type:'text'
          },
          {
              label:"File Save",
              key:"archiveFileSave",
            //   required:true,
              type:'text'
          }
        ]
      };
      const deadInquiryDeskInputTypes = {
        fields: [
          {
              label:"Restore",
              key:"deadInquiryRestore",
            //   required:true,
              type:'text'
          }
        ]
      };
      const userManagementInputTypes = {
        fields: [
          {
              label:"Small Password",
              key:"userSmallPassword",
            //   required:true,
              type:'text'
          },
          {
              label:"Password Not Matched",
              key:"userPasswordMatch",
            //   required:true,
              type:'text'
          },
          {
              label:"Password Changed",
              key:"userPasswordChanged",
            //   required:true,
              type:'text'
          },
          {
              label:"User Update",
              key:"userUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"User Added",
              key:"userAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Group Created",
              key:"userGroupCreated",
            //   required:true,
              type:'text'
          },
          {
              label:"Group Updated",
              key:"userGroupUpdated",
            //   required:true,
              type:'text'
          },
          {
              label:"Group Deleted",
              key:"userGroupDeleted",
            //   required:true,
              type:'text'
          },
          {
              label:"Group Replica",
              key:"userGroupReplica",
            //   required:true,
              type:'text'
          },
          {
              label:"TeleCaller Added",
              key:"telecallerAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"TeleCaller Deleted",
              key:"telecallerDeleted",
            //   required:true,
              type:'text'
          }
        ]
      };

      const payrollManagementInputTypes = {
        fields: [
          {
              label:"Holiday Add",
              key:"holidayAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Salary Add",
              key:"staffSalaryAdd",
            //   required:true,
              type:'text'
          },
          {
              label:"Salary Update",
              key:"staffSalaryUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Salary Delete",
              key:"staffSalaryDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const templateManagementInputTypes = {
        fields: [
          {
              label:"Template Add",
              key:"templateAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Template Update",
              key:"templateUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Template Delete",
              key:"templateDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const knowledgeBaseInputTypes = {
        fields: [
          {
              label:"Knowledge Base Add",
              key:"knowledgeBaseAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Knowledge Base Update",
              key:"knowledgeBaseUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Knowledge Base Delete",
              key:"knowledgeBaseDelete",
            //   required:true,
              type:'text'
          },
          {
              label:"Title Required",
              key:"knowledgeBaseTitle",
            //   required:true,
              type:'text'
          },
          {
              label:"Description Required",
              key:"knowledgeBaseDescrption",
            //   required:true,
              type:'text'
          },
          {
              label:"File Required",
              key:"knowledgeBaseFile",
            //   required:true,
              type:'text'
          },
          {
              label:"Knowledge Base Category Add",
              key:"knowledgeBaseCategoryAdd",
            //   required:true,
              type:'text'
          },
          {
              label:"Knowledge Base Category Update",
              key:"knowledgeBaseCategoryUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Knowledge Base Category Delete",
              key:"knowledgeBaseCategoryDelete",
            //   required:true,
              type:'text'
          },
          
        ]
      };
      const autoFollowUpInputTypes = {
        fields: [
          {
              label:"Auto Followup Add",
              key:"autoFollowAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Auto Followup Update",
              key:"autoFollowUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Auto Follow Up Delete",
              key:"autoFollowDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allCountriesInputTypes = {
        fields: [
          {
              label:"Country Add",
              key:"countryAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Country Update",
              key:"countryUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Country Delete",
              key:"countryDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allStatesInputTypes = {
        fields: [
          {
              label:"State Add",
              key:"stateAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"State Update",
              key:"stateUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"State Delete",
              key:"stateDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allCitiesInputTypes = {
        fields: [
          {
              label:"City Add",
              key:"cityAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"City Update",
              key:"cityUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"City Delete",
              key:"cityDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allUniversitiesInputTypes = {
        fields: [
          {
              label:"University Add",
              key:"universityAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"University Update",
              key:"universityUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"University Delete",
              key:"universityDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allCampusInputTypes = {
        fields: [
          {
              label:"Campus Add",
              key:"campusAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Campus Update",
              key:"campusUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Campus Delete",
              key:"campusDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allChannelPartnersInputTypes = {
        fields: [
          {
              label:"Channel Partner Add",
              key:"channelPartnerAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Channel Partnet Update",
              key:"channelPartnerUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Channel Partner Delete",
              key:"channelPartnerDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allCousesInputTypes = {
        fields: [
          {
              label:"Course Add",
              key:"courseAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Course Update",
              key:"courseUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Course Delete",
              key:"courseDelete",
            //   required:true,
              type:'text'
          },
          {
              label:"Course Transfer",
              key:"courseTransfer",
            //   required:true,
              type:'text'
          },
          {
              label:"Course Copy",
              key:"courseCopy",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allBranchesInputTypes = {
        fields: [
          {
              label:"Branch Add",
              key:"branchAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Branch Update",
              key:"branchUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Branch Delete",
              key:"branchDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allFacultiesInputTypes = {
        fields: [
          {
              label:"Faculty Add",
              key:"facultyAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Faculty Update",
              key:"facultyUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Faculty Delete",
              key:"facultyDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allLevelsInputTypes = {
        fields: [
          {
              label:"Levels Add",
              key:"levelsAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Levels Update",
              key:"levelsUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Levels Delete",
              key:"levelsDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allVisaCategoryInputTypes = {
        fields: [
          {
              label:"Visa Category Add",
              key:"visaCategoryAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Visa Category Update",
              key:"visaCategoryUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Visa Category Delete",
              key:"visaCategorytDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const plansInputTypes = {
        fields: [
          {
              label:"Plan Add",
              key:"planAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Plan Update",
              key:"planUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Plan Delete",
              key:"plantDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const vendorsInputTypes = {
        fields: [
          {
              label:"Vendor Add",
              key:"vendorAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Vendor Update",
              key:"vendorUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Vendor Delete",
              key:"vendorDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const ratingsInputTypes = {
        fields: [
          {
              label:"Ratings Add",
              key:"ratingAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Ratings Update",
              key:"ratingUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Ratings Delete",
              key:"ratingDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const subRatingsInputTypes = {
        fields: [
          {
              label:"Sub Ratings Add",
              key:"subRatingAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Sub Ratings Update",
              key:"subRatingUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Sub Ratings Delete",
              key:"subRatingDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const sourceInputTypes = {
        fields: [
          {
              label:"Source Add",
              key:"sourceAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Source Update",
              key:"sourceUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Source Delete",
              key:"sourceDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const allBoardsInputTypes = {
        fields: [
          {
              label:"All Board Add",
              key:"allBoardAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"All Board Update",
              key:"allBoardUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"All Board Delete",
              key:"allBoardDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const boardRankingsInputTypes = {
        fields: [
          {
              label:"Board Ranking Add",
              key:"boardRankingAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Board Ranking Update",
              key:"boardRankingUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Board Ranking Delete",
              key:"boardRankingDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const gendersInputTypes = {
        fields: [
          {
              label:"Genders Add",
              key:"genderAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Genders Update",
              key:"genderUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Genders Delete",
              key:"genderDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const maritalStatusInputTypes = {
        fields: [
          {
              label:"Marital Status Add",
              key:"maritalStatusAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Marital Status Update",
              key:"maritalStatusUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Marital Status Delete",
              key:"maritalStatusDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const restrictedLocationInputTypes = {
        fields: [
          {
              label:"Restricted Location Add",
              key:"restrictedLocationAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Restricted Location Update",
              key:"restrictedLocationUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Restricted Location Delete",
              key:"restrictedLocationDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const restrictedLocalUniversityInputTypes = {
        fields: [
          {
              label:"Restricted Local University Add",
              key:"restrictedLocalUniversityAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Restricted Local University Update",
              key:"restrictedLocalUniversityUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Restricted Local University Delete",
              key:"restrictedLocalUniversityDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const contactDetailsInputTypes = {
        fields: [
          {
              label:"Contact Details Add",
              key:"contactDetailsAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Contact Details Update",
              key:"contactDetailsUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Contact Details Delete",
              key:"contactDetailsDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const IPInputTypes = {
        fields: [
          {
              label:"IP Add",
              key:"ipAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"IP Update",
              key:"ipUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"IP Delete",
              key:"ipDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const notAllowedIpInputTypes = {
        fields: [
          {
              label:"Not Allowed IP Add",
              key:"notAllowedIpAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Not Allowed IP Update",
              key:"notAllowedIpUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Not Allowed IP Delete",
              key:"notAllowedIpDelete",
            //   required:true,
              type:'text'
          }
        ]
      };
      const leadCounsellorChangeInputTypes = {
        fields: [
          {
              label:"Lead Counsellor Change",
              key:"leadCounsellorChange",
            //   required:true,
              type:'text'
          },
          {
              label:"Expect New Lead Counsellor",
              key:"expectNewLeadCounsellor",
            //   required:true,
              type:'text'
          }
        ]
      };
      const agreementManagementInputTypes = {
        fields: [
          {
              label:"Agreement Add",
              key:"agreementAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Agreement Update",
              key:"agreementUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Agreement Delete",
              key:"agreementDelete",
            //   required:true,
              type:'text'
          },

        ]
      };
      const appointmentInputTypes = {
        fields: [
          {
              label:"Appintment Add",
              key:"appointmentAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Appintment Postpone",
              key:"appointmentPostpone",
            //   required:true,
              type:'text'
          },
          {
              label:"Appintment Cancel",
              key:"appointmentCancel",
            //   required:true,
              type:'text'
          },

        ]
      };
      const universityCommissionInputTypes = {
        fields: [
          {
              label:"University Commission Add",
              key:"universityCommissionAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"University Commission Update",
              key:"universityCommissionUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"University Commission Delete",
              key:"universityCommissionDelete",
            //   required:true,
              type:'text'
          },

        ]
      };
      const courseCommissionInputTypes = {
        fields: [
          {
              label:"Course Commission Add",
              key:"courseCommissionAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Course Commission Update",
              key:"courseCommissionUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Course Commission Delete",
              key:"courseCommissionDelete",
            //   required:true,
              type:'text'
          },

        ]
      };
      const taxDetailInputTypes = {
        fields: [
          {
              label:"Tax Details Add",
              key:"taxDetailsAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Tax Details Update",
              key:"taxDetailsUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Tax Details Delete",
              key:"taxDetailsDelete",
            //   required:true,
              type:'text'
          },

        ]
      };
      const companyDetailsInputTypes = {
        fields: [
          {
              label:"Company Details Add",
              key:"companyDetailsAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Company Details Update",
              key:"companyDetailsUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Company Details Delete",
              key:"companyDetailsDelete",
            //   required:true,
              type:'text'
          },

        ]
      };
      const invoiceToDetailsInputTypes = {
        fields: [
          {
              label:"Invoice To Details Add",
              key:"invoiceToDetailsAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Invoice To Details Update",
              key:"invoiceToDetailsUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Invoice To Details Delete",
              key:"invoiceToDetailsDelete",
            //   required:true,
              type:'text'
          },

        ]
      };
      
      const allInvoicesInputTypes = {
        fields: [
          {
              label:"Send Invoice",
              key:"invoiceSend",
            //   required:true,
              type:'text'
          }

        ]
      };

      const counsellorTargetInputTypes = {
        fields: [
          {
              label:"Counsellor Target Add",
              key:"counsellorTargetAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Counsellor Target Update",
              key:"counsellorTargetUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Counsellor Target Delete",
              key:"counsellorTargetDelete",
            //   required:true,
              type:'text'
          },
        ]
      };
      const companyRulesInputTypes = {
        fields: [
          {
              label:"Company Rules Add",
              key:"companyRulesAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Company Rules Update",
              key:"companyRulesUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Company Rules Delete",
              key:"companyRulesDelete",
            //   required:true,
              type:'text'
          },
        ]
      };
      const suggestionsInputTypes = {
        fields: [
          {
              label:"Suggestions Add",
              key:"suggestionsAdded",
            //   required:true,
              type:'text'
          },
          {
              label:"Suggestions Update",
              key:"suggestionsUpdate",
            //   required:true,
              type:'text'
          },
          {
              label:"Suggestions Delete",
              key:"suggestionsDelete",
            //   required:true,
              type:'text'
          },
          {
              label:"Suggestions Accept",
              key:"suggestionsAccept",
            //   required:true,
              type:'text'
          },
        ]
      };
      const searchLogsInputTypes = {
        fields: [
          {
              label:"Search Logs Add",
              key:"searchLogsAdded",
            //   required:true,
              type:'text'
          }
        ]
      };
      const syncUserInputTypes = {
        fields: [
          {
              label:"Sync User",
              key:"syncUser",
            //   required:true,
              type:'text'
          }
        ]
      };
      const commonInputTypes = {
        fields: [
          {
              label:"Settings Saved",
              key:"settingsSaved",
            //   required:true,
              type:'text'
          },
          {
              label:"File Saved",
              key:"fileSaved",
            //   required:true,
              type:'text'
          },
          {
            label:"File Delete",
            key:"deleteFile",
            // required:true,
            type:'text'
          },
          {
              label:"Updated",
              key:"updated",
            //   required:true,
              type:'text'
          },
          {
              label:"Follow Up Add",
              key:"followUpAdd",
            //   required:true,
              type:'text'
          },
          {
              label:"Uploaded",
              key:"uploaded",
            //   required:true,
              type:'text'
          },
          {
              label:"Error Data",
              key:"errorData",
            //   required:true,
              type:'text'
          },
          {
            lable:"Notification Saved",
            key:'notificationSaved',
            // required:true,
            type:'text'
          }

        ]
      };
    return (
      <PageHeaderWrapper title={` Notification Templates : ${this.state.allNotifications.length} `}>
        <Card bordered={true}>
            <Form onSubmit={this.handleSubmit}>
                {/* <Row>
                    <Col>
                        <h2>Login Alerts</h2>
                        <GetAllFormFields
                            inputSchema={loginInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row> */}
                <Row>
                    <Col>
                        <h2>Task Management Alerts</h2>
                        <GetAllFormFields
                            inputSchema={taskManagementInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Add/ Update Lead Alerts</h2>
                        <GetAllFormFields
                            inputSchema={addUpdateLeadInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Add/ Update Raw Inquiry Alerts</h2>
                        <GetAllFormFields
                            inputSchema={addUpdateRawInquiryInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Add/ Update Visitor Visa Inquiry Alerts</h2>
                        <GetAllFormFields
                            inputSchema={addUpdateVisitorVisaInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Facebook/ Google Inquiry Alerts</h2>
                        <GetAllFormFields
                            inputSchema={facebookAndGoogleInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Counselling Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={counsellingDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Registration Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={registrationDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Submit Fees Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={submitFeesDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Account Payments Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={accountPaymentsDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Application Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={applicationDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Visa Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={visaDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Archive Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={archiveDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Dead Inquiry Desk Alerts</h2>
                        <GetAllFormFields
                            inputSchema={deadInquiryDeskInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>User Management Alerts</h2>
                        <GetAllFormFields
                            inputSchema={userManagementInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Payroll Management Alerts</h2>
                        <GetAllFormFields
                            inputSchema={payrollManagementInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Template Management Alerts</h2>
                        <GetAllFormFields
                            inputSchema={templateManagementInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Knowledge Base Alerts</h2>
                        <GetAllFormFields
                            inputSchema={knowledgeBaseInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Auto Follow Up Alerts</h2>
                        <GetAllFormFields
                            inputSchema={autoFollowUpInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Countries Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allCountriesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All States Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allStatesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Cities Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allCitiesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All University Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allUniversitiesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Campus Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allCampusInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Channel Partners Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allChannelPartnersInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Courses Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allCousesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Branches Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allBranchesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Faculties Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allFacultiesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Levels Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allLevelsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Visa Category Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allVisaCategoryInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Plans Alerts</h2>
                        <GetAllFormFields
                            inputSchema={plansInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Vendors Alerts</h2>
                        <GetAllFormFields
                            inputSchema={vendorsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Ratings Alerts</h2>
                        <GetAllFormFields
                            inputSchema={ratingsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Sub Ratings Alerts</h2>
                        <GetAllFormFields
                            inputSchema={subRatingsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Source Alerts</h2>
                        <GetAllFormFields
                            inputSchema={sourceInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Boards Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allBoardsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Board Rankings Alerts</h2>
                        <GetAllFormFields
                            inputSchema={boardRankingsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Genders Alerts</h2>
                        <GetAllFormFields
                            inputSchema={gendersInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Marital Status Alerts</h2>
                        <GetAllFormFields
                            inputSchema={maritalStatusInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Restricted Location Alerts</h2>
                        <GetAllFormFields
                            inputSchema={restrictedLocationInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Restricted Local University Alerts</h2>
                        <GetAllFormFields
                            inputSchema={restrictedLocalUniversityInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Contact Details Alerts</h2>
                        <GetAllFormFields
                            inputSchema={contactDetailsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Add Ip Alerts</h2>
                        <GetAllFormFields
                            inputSchema={IPInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Not Allowed Ip Alerts</h2>
                        <GetAllFormFields
                            inputSchema={notAllowedIpInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Lead Counsellor Alerts</h2>
                        <GetAllFormFields
                            inputSchema={leadCounsellorChangeInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Agreement Management Alerts</h2>
                        <GetAllFormFields
                            inputSchema={agreementManagementInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Appointment Alerts</h2>
                        <GetAllFormFields
                            inputSchema={appointmentInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>University Commission Alerts</h2>
                        <GetAllFormFields
                            inputSchema={universityCommissionInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Course Commission Alerts</h2>
                        <GetAllFormFields
                            inputSchema={courseCommissionInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Tax Detail Alerts</h2>
                        <GetAllFormFields
                            inputSchema={taxDetailInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Company Detail Alerts</h2>
                        <GetAllFormFields
                            inputSchema={companyDetailsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Invoice to Details Alerts</h2>
                        <GetAllFormFields
                            inputSchema={invoiceToDetailsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>All Invoice Alerts</h2>
                        <GetAllFormFields
                            inputSchema={allInvoicesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Counsellor Target Alerts</h2>
                        <GetAllFormFields
                            inputSchema={counsellorTargetInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Company Rules Alerts</h2>
                        <GetAllFormFields
                            inputSchema={companyRulesInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Suggestions Alerts</h2>
                        <GetAllFormFields
                            inputSchema={suggestionsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Search Logs Alerts</h2>
                        <GetAllFormFields
                            inputSchema={searchLogsInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Sync User Alerts</h2>
                        <GetAllFormFields
                            inputSchema={syncUserInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2>Common Alertss</h2>
                        <GetAllFormFields
                            inputSchema={commonInputTypes}
                            refresh={this.refreshFxn}
                            getFieldDecorator={getFieldDecorator}
                        />
                    </Col>
                </Row>
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
            </Form>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default notificationTemplates
